export enum ValidationReferenceType {
  ValidationRuleValue="ValidationRuleValue",
  ReferencedPropertyValue = "ReferencedPropertyValue"
}
